
import Cookies from 'js-cookie';

export default class CookieBar {

    constructor() {
        this.settings = {
            cookieBtn: $('[data-btn="cookie-btn"]'),
            el: $('[data-block="cookie-bar"]')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.el.length) {
            const cookie = Cookies.get('[data-block="cookie-bar"]');

            if (cookie === 'hidden-bar') {
                this.settings.el.hide();
            } else {
                this.settings.el.show();
            }

            this.settings.cookieBtn.on('click', () => {
                this.settings.el.fadeOut();
                Cookies.set('[data-block="cookie-bar"]', 'hidden-bar', { expires: 90 });
            });

        }

    }

};

new CookieBar();
